import { render, staticRenderFns } from "./digital-donation-receipt-config.vue?vue&type=template&id=7ed9ff48"
import script from "./digital-donation-receipt-config.vue?vue&type=script&lang=ts"
export * from "./digital-donation-receipt-config.vue?vue&type=script&lang=ts"
import style0 from "./digital-donation-receipt-config.vue?vue&type=style&index=0&id=7ed9ff48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports